export const resultsAd = { // same as resultsBottom but shows up for desktop
  id: 'div-gpt-ad-1516660198643-0',
  sizes: [300, 250],
  adSlot: '/1010197/BS_FlightTrackerFlightPicker_top_300x250',
};
